import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    changePinInfo: `**Remember it!** You can change it at any time in the app but you will have to make a cash withdrawal, which is charged {0}, to validate it.
Please note that you must use this card by entering your PIN number before you can pay contactless.`,
    continue: 'Continue',
    noPinInfo:
      'Please note that you must use this card by entering your PIN number before you can pay contactless.',
    noPinLabel: `Your card has been successfully activated`,
    pinLabel: `Here's your PIN number:`,
  },
  fr: {
    changePinInfo: `**Ne l'oubliez pas !** Vous pouvez le modifier à tout moment dans l'application mais vous devrez effectuer un retrait d'espèces, facturé {0}, pour le valider.
Notez que vous devez utiliser cette carte en saisissant votre code PIN avant de pouvoir payer sans contact.`,
    continue: 'Continuer',
    noPinInfo:
      'Veuillez noter que vous devez utiliser cette carte en entrant votre code PIN avant de pouvoir payer sans contact.',
    noPinLabel: 'Votre carte a bien été activée',
    pinLabel: 'Voici votre code PIN :',
  },
} as const);

export default locales;
